import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=c5654c56&scoped=true&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"
import style0 from "./interface.vue?vue&type=style&index=0&id=c5654c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5654c56",
  null
  
)

export default component.exports